import { convertToCommaString } from "../../helpers/Converter"
import "../../styles/FinalResultsItem.css"
export const FinalResultsItem = ({ data, size }) => {
    return (
        <div>
            <div style={{ margin: "14px" }}>
                <div className={`final-results-item-container-${size}`}>
                    <img className={`final-results-item-image-${size}`} src={`${data.photoUrl}`} alt=""></img>
                    <div className={`final-results-details`}>
                        {<p className="final-results-item-player-name">{data.name}</p>}
                        {<p style={{ marginTop: "-10px" }}>{"₹"+convertToCommaString(data.wealth)}</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}